import React from 'react';

/**
 * Layout for public-facing content pages (About, Blog, FAQ).
 * Mirrors AccountLayout's container so the same component renders consistently
 * whether it's accessed via `/faq` (public) or `/dashboard/account/faq` (logged-in).
 *
 * - Same width: max-w-7xl with 10% horizontal padding
 * - Same background: dark mode #0a0a0a (matches dashboard)
 * - Reserves room for the fixed top header (pt-20)
 */
const PublicContentLayout = ({ children }) => {
    return (
        <div className="bg-gray-50 dark:bg-[#0a0a0a] text-gray-900 dark:text-white min-h-screen transition-colors duration-300">
            <main className="w-full bg-gray-50 dark:bg-[#0a0a0a] transition-colors duration-300 pt-20 pb-16">
                <div className="max-w-7xl mx-auto px-[10%] py-6 md:py-12">
                    {children}
                </div>
            </main>
        </div>
    );
};

export default PublicContentLayout;
